import React from "react";
import i18n from "i18n";

const ErrorsContainer = (errors) => {
  const errorFields = Object.values(errors);
  const errorFieldsObject = Object.values(errorFields);
  const errorFieldsNames = errorFieldsObject.map((error) => Object.keys(error));

  const hebrewNames = errorFieldsNames.reduce((acc, error) => {
    if (Array.isArray(error)) {
      const nestedErrors = error.map((nestedError) => i18n.t(nestedError));
      return [...acc, ...nestedErrors];
    }
    return [...acc, i18n.t(error)];
  }, []);
  const errorMessage = <span>{hebrewNames.join(", ")}</span>;

  return (
    <div className="error-message">
      {i18n.t("globalValidationMessage")}:<div>{errorMessage}</div>
    </div>
  );
};
export default ErrorsContainer;
